import React from 'react'
import { ReactComponent as AddIcon } from '../../../../assets/svg/add.svg';
import styles from './AddNewSafetyTeam.module.scss'

interface IAddNewSafetyTeamProps {
  onAddNew: () => void
}

const AddNewSafetyTeam = ({
  onAddNew,
}: IAddNewSafetyTeamProps) => {
  return (
    <div className={styles.addButtonWrapper}>
      <div className={styles.addButtonContainer}>
        <button
          className={styles.addButton}
          onClick={onAddNew}
          type="button"
        >
          <AddIcon />
          <span>Add new</span>
        </button>
      </div>
    </div>
  )
}

export default AddNewSafetyTeam